import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { AlertComponent } from '../app/shared/components/alert/alert.component';
import { LoaderComponent } from '../../presentation/app/shared/components/loader/loader.component';
import { FloatUIModule } from '@shared/floatui/floatui.module';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, AlertComponent, LoaderComponent, FloatUIModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {}
